import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CmsContentService } from './cms-content/cms-content.service';
import { CmsFacilitiesService } from './cms-facilities/cms-facilities.service';
import { CmsFacilityResolver } from './cms-facility/cms-facility.resolver';
import { CmsFooterService } from './cms-footer/cms-footer.service';
import { CmsPagesService } from './cms-pages/cms-pages.service';
import { PagePathResolver } from './page-path/page-path.resolver';

@NgModule({
  imports: [CommonModule],
  providers: [
    CmsContentService,
    CmsFooterService,
    CmsPagesService,
    PagePathResolver,
    CmsFacilitiesService,
    CmsFacilityResolver,
  ],
})
export class RsCmsServicesModule {}
